import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// import { easing } from 'jquery';

window.addEventListener('load', () => {
	AOS.init({
		disable: 'mobile',
		duration: 800,
		easing: 'ease-out-quad',
		once: true,
		anchorPlacement: 'top-bottom',
	});
	// Init intersection observer to handle init  if slider is in viewport
	if ('IntersectionObserver' in window) {
		// Create options for observer
		const observerOptions = {
			root: null,
			rootMargin: '400px',
			threshold: 0,
		};

		const lazyObserver = new IntersectionObserver((entries, observer) => {
			// Handle all entries (all images in this case)
			entries.forEach((entry) => {
				// Check if slider should be active
				if (entry.isIntersecting) {
					entry.target.classList.add('aos-animate');
				}
			});
		}, observerOptions);

		// Init observer on slider
		const elementToAnimate = document.querySelectorAll(`[data-aos]`);

		if (elementToAnimate.length) {
			elementToAnimate.forEach((element) => {
				lazyObserver.observe(element);
			});
		}
	}
});
